// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1FaCf","logo":"Header_logo__LQrFF"};